export const koalaImg = `${process.env.PUBLIC_URL}/assets/img/ci/img-koala-qrcode.svg`;